import { QueryCache, QueryClient } from "@tanstack/react-query";

import { shouldReportError } from "@/shared/http/shouldReportError";
import { ErrorMonitoringService } from "@/shared/services/ErrorMonitoringService";

export const queryClient = new QueryClient({
  // Mutations report through `defaultOptions` below; queries have no equivalent
  // hook, so a read that fails is only ever seen by whichever component renders
  // `query.error` — and most render a message and move on. Reporting from the
  // cache is what gives a broken read the same visibility a broken write has.
  //
  // React Query filters its own cancellations before calling this (query-core
  // only invokes it when `!isCancelledError(error)`); `shouldReportError`
  // handles the cancellation shapes that reach it by other routes.
  queryCache: new QueryCache({
    onError: (err, query) => {
      if (shouldReportError(err)) {
        ErrorMonitoringService.captureError(err, { queryKey: query.queryKey });
      }
    },
  }),
  defaultOptions: {
    queries: {
      // Our HttpClient already retries requests
      retry: false,

      // Default stale time of 5 minutes
      staleTime: 1000 * 60 * 5,
    },
    mutations: {
      onError: (err, variables) => {
        // Expected, user-resolvable failures (e.g. a dashboard revision
        // conflict) have their own UI and are not defects — reporting them
        // would bury real failures in noise.
        if (shouldReportError(err)) {
          ErrorMonitoringService.captureError(err, { variables });
        }
      },
    },
  },
});
